import axios from 'axios';
import AjaxResponseInterface from '@/interfaces/AjaxResponseInterface';
import ValidationResponseInterface from '@/interfaces/ValidationResponseInterface';

class AdventAPI {
  static submit(form: string, data: unknown): Promise<ValidationResponseInterface> {
    return new Promise<ValidationResponseInterface>((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }
      axios.post<ValidationResponseInterface>(`${ajaxUrl}?action=advent_calender`, {
        form,
        data,
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as ValidationResponseInterface;
        resolve(ajaxResponseData);
      }).catch((e) => {
        reject(e.response.data);
      });
    });
  }
}

export default AdventAPI;
